import * as preact from "preact";

import LovePath from "./LovePath";
import { imageUrl } from "../../foundation/utils/image";
import classname from "../../foundation/utils/classname";

import "./style.css";

function IntegrationImage({ logo, color, toZeplin = false }) {
    return (
        <div class={classname("integrationImage", { toZeplin })}>
            <img width="36" class="zeplinLogo" src={imageUrl("img/icZeplin.svg")}/>
            <LovePath stopColor={color} toZeplin={toZeplin}/>
            {typeof logo === "string" ? <img height="36" src={logo}/> : logo}
        </div>
    );
}

export default IntegrationImage;
